import type { RangeTuple } from 'fuse.js';
import { Fragment, type ReactNode } from 'react';

interface Props {
  className?: string;
  ranges: readonly RangeTuple[];
  text: string;
}

export default function HighlightSearchRange({ ranges, text, className }: Props) {
  if (!ranges.length) return <span className={className}>{text}</span>;

  let lastHighlightedIndex = 0;
  const nodes: ReactNode[] = [];

  for (const [start, end] of ranges) {
    // Broken range, ignore
    if (start < lastHighlightedIndex || end < start) {
      // eslint-disable-next-line no-console
      console.warn(`Broken range in <Highlight>: ${start}-${end}, last: ${lastHighlightedIndex}`);
      continue;
    }

    if (start > lastHighlightedIndex) {
      nodes.push(
        <Fragment key={`t${lastHighlightedIndex}-${start}`}>{text.slice(lastHighlightedIndex, start)}</Fragment>,
      );
    }
    nodes.push(
      <span
        className={className}
        key={`${start}-${end}`}>
        {text.slice(start, end + 1)}
      </span>,
    );
    lastHighlightedIndex = end + 1;
  }

  if (text.length > lastHighlightedIndex) {
    nodes.push(<Fragment key='last'>{text.slice(lastHighlightedIndex, text.length)}</Fragment>);
  }

  return nodes;
}
